import { render, staticRenderFns } from "./OCMailAuthentication.html?vue&type=template&id=5c7d4a42&scoped=true&"
import script from "./OCMailAuthentication.ts?vue&type=script&lang=ts&"
export * from "./OCMailAuthentication.ts?vue&type=script&lang=ts&"
import style0 from "./OCMailAuthentication.css?vue&type=style&index=0&id=5c7d4a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d4a42",
  null
  
)

export default component.exports